interface CopilotMessageHTMLElement {
  element: HTMLElement;
  mikeId: string;
  mikeInitialized: boolean;
  mikeVisible: boolean;
  mikePreparing: boolean;
}

export const getCopilotMessageHTMLElements = () => {
  return (
    Array.from(document.querySelectorAll(".mike-item")) as HTMLElement[]
  ).map<CopilotMessageHTMLElement>((element: HTMLElement) => {
    const attributes: CopilotMessageHTMLElement = {
      element,
      mikeId: "",
      mikeInitialized: false,
      mikeVisible: false,
      mikePreparing: false,
    };

    for (const key in element.dataset) {
      if (key.startsWith("mike")) {
        const value = element.dataset[key] as string;
        let boolValue = false;
        let stringValue = "";

        if (value.toLowerCase() === "true" || value.trim() === "") {
          boolValue = true;
        } else if (value.toLowerCase() === "false") {
          boolValue = false;
        } else {
          stringValue = value;
        }

        if (key === "mikeId") {
          attributes.mikeId = stringValue;
        } else if (key === "mikeInitialized") {
          attributes.mikeInitialized = boolValue;
        } else if (key === "mikeVisible") {
          attributes.mikeVisible = boolValue;
        } else if (key === "mikePreparing") {
          attributes.mikePreparing = boolValue;
        }
      }
    }

    return attributes;
  });
};

export const getMikeElements = () => {
  return Array.from(document.querySelectorAll(".mike-item")) as HTMLElement[];
};

export const getElementMikeId = (target?: Element) => {
  return target?.getAttribute("data-mike-id") || "";
};

export const getElementMikeVisible = (target?: Element) => {
  return target ? target.getAttribute("data-mike-visible") === "true" : true;
};

export const getElementMikeInitialized = (target: Element) => {
  return target
    ? target.getAttribute("data-mike-initialized") === "true"
    : true;
};

export const setElementMikeVisible = (target: Element, visible: boolean) => {
  const ATTR = "data-mike-visible";

  const oldVisible = target.getAttribute(ATTR);
  const newVisible = visible.toString();
  target.setAttribute("data-mike-visible", newVisible);

  if (oldVisible != newVisible) {
    const event = new CustomEvent("mike-visible-changed");
    target.dispatchEvent(event);
  }
};

export const setElementMikeInitialized = (
  target: Element,
  initialized: boolean,
) => {
  target.setAttribute("data-mike-initialized", initialized.toString());
};

export const setElementMikePreparing = (
  target: Element,
  preparing: boolean,
) => {
  target.setAttribute("data-mike-preparing", preparing.toString());
};
